<p>forgot-password works!</p>